import React, { Component } from 'react'
import {FormattedMessage} from 'react-intl'
import { Button, Toolbar, ToolbarItem } from '@progress/kendo-react-buttons';
import {withStyles} from '@material-ui/core'

const style= theme =>({
    toolbar:{
        marginBottom:'1%', 
        zIndex: '10'
    }
})

export class cdToolbar extends Component {
    render() {
        const {classes,showForm} = this.props
            return(
                <div>
                 <React.Fragment>
                        <Toolbar className={classes.toolbar}>
                            <ToolbarItem>
                                <Button name="create" icon="plus" onClick={showForm}><FormattedMessage id="create" defaultMessage="Create"/></Button>
                            </ToolbarItem>
                        </Toolbar>
                    </React.Fragment>
            </div>
            )
    }
}

export default withStyles(style)(cdToolbar)
